import { z } from 'zod'
import { Id, Timestamp } from './common'

export const NotificationKind = z.enum(['interval_due_soon', 'interval_overdue'])

export const Notification = z.object({
  id: Id,
  kind: NotificationKind,
  title: z.string(),
  body: z.string(),
  link: z.string().nullable(),
  interval_id: Id.nullable(),
  created_at: Timestamp,
  read_at: Timestamp.nullable(),
})
export type Notification = z.infer<typeof Notification>

export const NotificationList = z.object({
  notifications: z.array(Notification),
  unread: z.number().int(),
})
export type NotificationList = z.infer<typeof NotificationList>

export const RegisterDeviceBody = z.object({
  platform: z.enum(['ios', 'android', 'web']),
  token: z.string().min(10).max(4096),
})
export type RegisterDeviceBody = z.infer<typeof RegisterDeviceBody>

export const Device = z.object({
  id: Id,
  platform: z.enum(['ios', 'android', 'web']),
  created_at: Timestamp,
})

/** POST /me/devices/test: how many registered devices the test push went to. */
export const TestPushResult = z.object({ devices: z.number().int() })
export type TestPushResult = z.infer<typeof TestPushResult>
